import { Button, alpha } from "@mui/material";

import type { FC, ReactNode } from "react";

interface CreateButtonProps {
  label: string;
  icon: ReactNode;
  href?: string;
  onClick?: () => void;
  analyticsId: string;
}

/** A pill with the brand gradient for its border, for starting something new. */
export const CreateButton: FC<CreateButtonProps> = ({
  label,
  icon,
  href,
  onClick,
  analyticsId,
}) => (
  <Button
    data-analytics-id={analyticsId}
    size="small"
    startIcon={icon}
    href={href}
    onClick={onClick}
    sx={(theme) => {
      const { paper } = theme.palette.background;
      const tint = alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity);
      const border = "linear-gradient(135deg, #00B6EF, #C24599) border-box";
      return {
        borderRadius: 999,
        px: 2,
        border: "1px solid transparent",
        color: "text.primary",
        background: `linear-gradient(${paper}, ${paper}) padding-box, ${border}`,
        "&:hover": {
          background: `linear-gradient(${tint}, ${tint}) padding-box, linear-gradient(${paper}, ${paper}) padding-box, ${border}`,
        },
        "& .MuiButton-startIcon": { color: "primary.main" },
      };
    }}
  >
    {label}
  </Button>
);
